import React from "react";
import { Switch, Route } from "react-router-dom";

function Routes() {
    return(
  <Switch>
    <Route path="/customers">
      <div>customers</div>
    </Route>
    <Route path="/account">
      <div>accounts</div>
    </Route>
    <Route path="/home">
      <div>home</div>
    </Route>
  </Switch>)
}

export default Routes;